import React, { useContext } from "react";
import { BannerContext } from '../../contexts/BannerDimensionsContext';


export default function Alert() {
  const { setError, error } = useContext(BannerContext);

  return (
    <div
    style={{
      background: 'rgba(0, 0, 0, 0.4)',
      position: 'absolute',
      width: '100vw',
      height: '100vh',
      zIndex: '998',
      display: error.show ? 'flex' : 'none',
      justifyContent: 'center',
      alignItems: 'center'
    }}
    >
    <div
      style={{
        position: 'absolute',
        width: '500px',
        zIndex: '999',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <div
        style={{
          background: 'white',
          width: '100%',
          minHeight: '100px',
          borderRadius: '10px 10px 0 0',
          maxHeight: '450px',
          overflow: 'auto'
        }}>
          <span style={{color: 'rgb(220, 26, 89)', fontSize: '20px', fontWeight: 'bold', padding: '20px 0px', textAlign: 'center', display: 'block', width: '100%'}}>{error.mensagem}</span>
      </div>
      <div
        style={{
          background: 'rgb(220, 26, 89)',
          width: '100%',
          height: '50px',
          borderRadius: '0 0 10px 10px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        onClick={() => setError({lista: [], mensagem: "", show: false})}
      >
        <span style={{color: 'white', fontWeight: 'bold'}}>OK</span>
        </div>
      </div>
    </div>
  )
}